import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import MiniHeader from '../../components/global/MiniHeader'
import { Container, Form, InputGroup } from 'react-bootstrap'
// import imageCarVehicle from '../../assets/img/newvehicle.png'
import { Controller, useForm } from 'react-hook-form'
// import PlateImage from '../../assets/img/licenseplate.png'
// import CalenderImage from '../../assets/img/calender.png'
// import ColorImage from '../../assets/img/colorpalet.png'
import { EMPTY_ARRAY, EMPTY_OBJECT, getSvgIcon } from '../../constants/globalConstants'
import { Circles } from 'react-loader-spinner'
import { EditVehicle, getVehilceData, postVehilce, getVehicleModelList } from '../../redux/actions/VehicleAction'
import { useNavigate } from 'react-router'
import { errorMessage } from '../../constants/errorMessage'
import { isPermissionExist, restrictInValidCharLicense, sortPortalPermissionByKey } from '../../utils/helper'
import { addEventLog } from '../../redux/actions/EventsLog'
import CONSTANTS from '../../redux/constants'
import { useSearchParams } from 'react-router-dom'

function VehicleForm(props) {
  const { dispatch, notify, setIsVehicleModalOpen, isInTransient, isInEdit, editData, isFetching, partnerDetails } = props
  const [stateList, setStateList] = useState(EMPTY_ARRAY)
  const [vehicleDefault, setVhicleDefault] = useState(false)
  const [vehicleDetailsList, setVehicleDetailsList] = useState(EMPTY_ARRAY)
  // const [vehicleModel, setvehicleModel] = useState(EMPTY_ARRAY)
  const [vehicleMakeList, setVehicleMakeList] = useState(EMPTY_ARRAY)
  const [vehicleModelList, setvehicleModelList] = useState(EMPTY_ARRAY)
  const [othermake, SetOtherMake] = useState(false)
  const [othermodel, SetOtherModel] = useState(false)
  const { register, handleSubmit, formState: { errors }, control, reset, setValue } = useForm()
  const partner = window.location.toString().split('/')[3]
  const navigate = useNavigate()

  const [searchParams] = useSearchParams()

  const queryLicensePlate = searchParams.get('license_plate')

  const [accessPermissions, setAccessPermissions] = useState('')

  useEffect(() => {
    const getAccessPermissionData = sortPortalPermissionByKey(partnerDetails, 'Restricted Permissions')
    setAccessPermissions(getAccessPermissionData)
  }, [EMPTY_ARRAY, partnerDetails])

  useEffect(() => {
    const vehicles = JSON.parse(localStorage.getItem('vehicle'))
    const isDefault = vehicles?.length == '0'
    setVhicleDefault(isDefault)
    const stateListData = JSON.parse(localStorage.getItem('faclityData'))
    setStateList(stateListData?.states)
    if (isInEdit && editData) {
      dispatch(getVehicleModelList()).then((res) => {
        let makeList = res.make
        makeList?.unshift({
          'id': 'Others',
          'name': 'Others',
          'mst_model': [{
            'id': 'Others',
            'make_id': 'Others',
            'name': 'Others'
          }]
        })
        setVehicleMakeList(makeList)
        setVehicleDetailsList(res)
        let modelData = makeList?.filter((v) => v.name == editData?.make)
        let makemodelList = (modelData?.length != 0 ? modelData?.[0]?.mst_model : [])
        let filteredmakemodelList = makemodelList?.filter((v) => v.name == editData?.model)
        makemodelList.unshift({
          'id': 'Others',
          'make_id': 'Others',
          'name': 'Others'
        })
        setvehicleModelList(makemodelList)
        SetOtherMake(modelData?.length == 0 ? true : false)
        SetOtherModel(filteredmakemodelList?.length == 0 ? true : false)

        reset(formValues => ({
          ...formValues,
          license_plate_number: editData?.license_plate_number ? editData?.license_plate_number : '',
          make: modelData?.length == 0 ? 'Others' : editData?.make_id ? editData?.make_id : '',
          maketext: editData?.make ? editData?.make : '',
          model: filteredmakemodelList?.length == 0 ? 'Others' : editData?.model_id ? editData?.model_id : '',
          modeltext: editData?.model_id ? '' : editData?.model ? editData?.model : '',
          color: editData?.color_id ? editData?.color_id : '',
          state_id: editData?.state_id ? editData?.state_id : '',
          status_default: (editData?.is_default) == '0' ? false : true,
          vehicle_type: editData?.vehicle_type_id ?? '',
        }))
      })
    }
    const geoState = stateListData?.facility?.geolocations?.state?.trim()
    const filteredState = stateListData?.states?.filter((item) => (item?.state_code === geoState || item?.name === geoState) ? item : 0)
    setValue('state_id', filteredState?.[0]?.id)

    dispatch(getVehicleModelList()).then((res) => {
      getVehicle(res)
    })

    if (queryLicensePlate) {
      handleLicenseChange({ 'target': { 'value': queryLicensePlate } })
    }

  }, [EMPTY_ARRAY])

  const getVehicle = (res) => {
    let makeList = res.make
    makeList?.unshift({
      'id': 'Others',
      'name': 'Others',
      'mst_model': [{
        'id': 'Others',
        'make_id': 'Others',
        'name': 'Others'
      }]
    })
    setVehicleMakeList(makeList)
    setVehicleDetailsList(res)

  }

  const getVehicleApi = () => {
    dispatch(getVehilceData()).then(() => {
    }).catch((err) => {
      notify('error', err)
      let errObject = {
        payload: '',
        error: err,
        errorMessage: err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong
      }
      dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} getFaciltyData-TransientForm.js-1831`))
    })
  }

  const handleChange = (e) => {
    e.preventDefault()
    const { name, value } = e.target

    if (name == 'make') {
      let modelData = vehicleDetailsList?.make?.filter((v) => v?.id == value)
      let modelList = (Object.values(modelData).length != 0 ? modelData?.[0]?.mst_model : [])
      let check = modelList?.some((value) => value?.name == 'Others')
      if (!check) {
        modelList.unshift({
          'id': 'Others',
          'make_id': 'Others',
          'name': 'Others'
        })
      } else {
        // If 'Others' exists, find and move it to the first index
        modelList = modelList.filter((value) => value?.name !== 'Others') // Remove 'Others' from the list
        modelList.unshift({
          'id': 'Others',
          'make_id': 'Others',
          'name': 'Others'
        }) // Add it back at the first index
      }

      setvehicleModelList(modelList)
      SetOtherMake(value == 'Others' ? true : false)
      setValue('maketext', '')
      setValue('model', '')
      setValue('modeltext', '')
    } else if (name == 'model') {
      SetOtherModel(value == 'Others' ? true : false)
      setValue('modeltext', '')
    }
  }

  const handleLicenseChange = (e) => {
    const { value } = e.target
    setValue('license_plate_number', restrictInValidCharLicense(value))
  }

  const onSubmit = (data) => {
    const model = (data?.model == 'Others' || data?.make == 'Others') ? data?.modeltext : data?.model

    const vehiclePayload = { ...data }

    const filterData = stateList?.filter((item) => Number(item?.id) == Number(data?.state_id) && item)
    vehiclePayload.state_name = filterData?.[0]?.state_code
    vehiclePayload.make = (data?.make == 'Others') ? (data?.maketext ? data?.maketext : '') : ''
    vehiclePayload.make_id = (data?.make == 'Others') ? '' : data?.make
    vehiclePayload.model = (data?.model == 'Others' || data?.make == 'Others') ? model : ''
    vehiclePayload.model_id = (data?.model == 'Others' || data?.make == 'Others') ? '' : data?.model
    vehiclePayload.license_plate = data?.license_plate_number ? data?.license_plate_number : ''
    vehiclePayload.color = data['color'] ? data['color'] : ''
    vehiclePayload.color_id = data['color'] ? data['color'] : ''

    // for the vehicle type
    const vehicleTypeFilter = vehicleDetailsList?.vehicletype?.filter((item) => Number(item?.id) == Number(data?.vehicle_type) && item)
    vehiclePayload.vehicle_type = vehicleTypeFilter?.[0]?.name ?? ''
    vehiclePayload.vehicle_type_id = data?.vehicle_type ?? ''
    // vehicle type end

    let checkMakeModel = false
    if (data?.make == 'Others') {
      checkMakeModel = vehicleDetailsList?.make?.some((value) => value.name.toLowerCase() == data?.maketext.toLowerCase())
      if (checkMakeModel) {
        notify('error', 'You can not add duplicate make.')
      }
    } else if (data?.make != 'Others' && data?.model == 'Others') {
      let makeList = vehicleDetailsList?.make?.filter((v) => v.id == data?.make)

      if (makeList.length > 0) {
        checkMakeModel = makeList[0]?.mst_model?.some((model) => model.name.toLowerCase() == data?.modeltext.toLowerCase())
        if (checkMakeModel) {
          notify('error', 'You can not add duplicate model.')
        }
      }
    }



    delete data['maketext']
    delete data['modeltext']
    delete data['license_plate_number']
    if (checkMakeModel) {
      return false
    } else {
      if (isInEdit && editData?.id) {
        const sign_in = JSON.parse(localStorage.getItem('sign_in'))
        vehiclePayload.id = editData?.id
        vehiclePayload.user_id = sign_in?.user?.id
        vehiclePayload.status_default = Number(data?.status_default) === 0 ? false : true
        dispatch(EditVehicle(vehiclePayload)).then((res) => {
          if (res?.data && res?.data !== null) {
            notify('success', 'Vehicle updated successfully')
            if (!isInTransient) {
              navigate(`/${partner}/vehicle-list`)
              // navigate(0)
            } else {
              getVehicleApi()
              setIsVehicleModalOpen(false)
            }
          } else {
            notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
            let errObject = {
              payload: data,
              error: res,
              errorMessage: res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong
            }
            dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} EditVehicle-VehicleForm.js-161`))
          }
        }).catch((err) => {
          notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
          let errObject = {
            payload: data,
            error: err,
            errorMessage: err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong
          }
          dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} EditVehicle-VehicleForm.js-161`))
        })
      } else {
        dispatch(postVehilce(vehiclePayload)).then((res) => {
          if (res?.data && res?.data !== null) {
            notify('success', 'Vehicle added successfully')
            if (!isInTransient) {
              navigate(`/${partner}/vehicle-list`)
              // navigate(0)
            } else {
              getVehicleApi()
              setIsVehicleModalOpen(false)
            }
          } else {
            notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
            let errObject = {
              payload: data,
              error: res,
              errorMessage: res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong
            }
            dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} PostVehicle-VehicleForm.js-192`))
          }
        }).catch((err) => {
          notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
          let errObject = {
            payload: data,
            error: err,
            errorMessage: err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong
          }
          dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} PostVehicle-VehicleForm.js-192`))
        })
      }
    }
  }

  return (
    <div>
      {(!isInTransient) && <MiniHeader isDisplayBack title={(isInEdit) ? 'EDIT VEHICLE' : 'ADD NEW VEHICLE'} />}
      <Container className='text-center justify-content-center'>
        {/* <Image className='img-20 mt-2 mb-3' src={imageCarVehicle}/> */}
        <span className='d-inline-block mt-2 mb-3' style={{ height: '50px', width: '50px' }}> {getSvgIcon('AddCardCar', 'var(--bs-primary)')}</span>
        <Form onSubmit={handleSubmit(onSubmit)} className='vehicleForm'>
          <InputGroup className="mb-3">
            <InputGroup.Text id="inputVehicleClass"><span className='mt-1' style={{ height: '27px', width: '27px' }}>{getSvgIcon('License_Plate', 'var(--bs-primary)')}</span></InputGroup.Text>
            <Form.Control placeholder="License Plate No." maxLength={10} minLength={2} name='license_plate_number' className='inputLoginVehicle' aria-label="Username" aria-describedby="basic-addon1"
              {...register('license_plate_number', {
                // pattern: { 
                //   value: /[^!@#$%^&*?\w\s-]/g, 
                //   message: 'Please enter a valid License Plate'
                // },
                required: { value: true, message: 'Please enter a valid license plate number' },
                minLength: { value: 2, message: 'Minimum 2 characters allowed' },
                maxLength: { value: 10, message: 'Maximum 10 characters allowed' }
              })}
              // value={getValues()?.license_plate_number}
              onChange={(e) => handleLicenseChange(e)}
            />
          </InputGroup>
          {errors?.license_plate_number && <Form.Text className="text-danger errorVehilceMessage">{errors?.license_plate_number?.message}</Form.Text>}
          <InputGroup className="mb-3">
            <InputGroup.Text id="inputVehicleClass"><span className='mt-1' style={{ height: '27px', width: '27px' }}>{getSvgIcon('Vehicle_make', 'var(--bs-primary)')}</span></InputGroup.Text>
            {/* <Form.Control placeholder="Vehicle Make" name="make" maxLength={4} minLength={4} className='inputLoginVehicle' aria-label="Username" aria-describedby="basic-addon1"
              {...register('make', {
                // required: true,
                // minLength: { value: 3, message: 'Please enter make year' },
                // maxLength: 10
              })}
            />  */}
            <Controller
              name='make'
              id='make'
              className='inputLoginVehicle'
              control={control}
              disabled={isInEdit ? true : false}
              // rules={{ required: true }}
              render={({ field }) => <Form.Select className="form-select selectPalceholdr inputLoginVehicle" name='make'  {...field} onChange={(e) => { field.onChange(e); handleChange(e) }} defaultValue={field.make}>
                <option>Please Select Make</option>
                {vehicleMakeList?.map((item, itemIndex) => <option key={itemIndex} value={item?.id}>{item?.name}</option>)}
              </Form.Select>}
            />
          </InputGroup>
          {othermake ? <InputGroup className="mb-3">
            <InputGroup.Text id="inputVehicleClass"><span className='mt-1' style={{ height: '27px', width: '27px' }}>{getSvgIcon('Vehicle_make', 'var(--bs-primary)')}</span></InputGroup.Text>
            <Form.Control placeholder="Make" name="maketext" maxLength={12} minLength={2} className='inputLoginVehicle' aria-label="Username" aria-describedby="basic-addon1"
              disabled={isInEdit ? true : false}
              {...register('maketext', {
                // required: true,
                // minLength: { value: 3, message: 'Please enter make year' },
                // maxLength: 10
              })}
            />

          </InputGroup> : ''}
          {/* {errors?.make?.type === 'required' && <Form.Text className="text-danger errorVehilceMessage">This field is required</Form.Text>} */}
          {/* {errors?.make?.type === 'minLength' && <Form.Text className="text-danger errorVehilceMessage">{errors?.make?.message}</Form.Text>} */}

          {!othermake ? <InputGroup className="mb-3">
            <InputGroup.Text id="inputVehicleClass"><span className='mt-1' style={{ height: '27px', width: '27px' }}>{getSvgIcon('Car', 'var(--bs-primary)')}</span></InputGroup.Text>
            {/* <Form.Control placeholder="Vehicle Model" name='model' maxLength={12} minLength={2} className='inputLoginVehicle' aria-label="Username" aria-describedby="basic-addon1"
              {...register('model', {
                // required: true,
                // minLength: { value: 3, message: 'Please enter vehicle model' },
                // maxLength: 10
              })}
            />  */}
            <Controller
              name='model'
              id='model'
              className='inputLoginVehicle'
              control={control}
              disabled={isInEdit ? true : false}
              // rules={{ required: true }}
              render={({ field }) => <Form.Select className="form-select selectPalceholdr inputLoginVehicle" name='model' {...field} onChange={(e) => { field.onChange(e); handleChange(e) }} defaultValue={field.value}>
                <option>Please Select Model</option>
                {(vehicleModelList?.length > 0) && vehicleModelList?.map((item, itemIndex) => <option key={itemIndex} value={item?.id}>{item?.name}</option>)}
              </Form.Select>}
            />
          </InputGroup> : ''}
          {(othermake || othermodel) ? <InputGroup className="mb-3">
            <InputGroup.Text id="inputVehicleClass"><span className='mt-1' style={{ height: '27px', width: '27px' }}>{getSvgIcon('Car', 'var(--bs-primary)')}</span></InputGroup.Text>
            <Form.Control placeholder="Model" name='modeltext' maxLength={12} minLength={2} className='inputLoginVehicle' aria-label="Username" aria-describedby="basic-addon1"
              disabled={isInEdit ? true : false}
              {...register('modeltext', {
                // required: true,
                // minLength: { value: 3, message: 'Please enter vehicle model' },
                // maxLength: 10
              })}
            />

          </InputGroup> : ''}
          {/* {errors?.model?.type === 'required' && <Form.Text className="text-danger errorVehilceMessage">This field is required</Form.Text>} */}
          {/* {errors?.model?.type === 'minLength' && <Form.Text className="text-danger errorVehilceMessage">{errors?.model?.message}</Form.Text>} */}

          {/* vehicle type input section start   */}
          {isPermissionExist(accessPermissions, 'Get Vehicle Type') ?
            <><InputGroup className="mb-3">
              <InputGroup.Text id="inputVehicleClass"><span className='mt-1' style={{ height: '27px', width: '27px' }}>{getSvgIcon('vehicle_type', 'var(--bs-primary)')}</span></InputGroup.Text>
              <Controller
                name='vehicle_type'
                id='vehicle_type'
                className='inputLoginVehicle'
                control={control}
                disabled={isInEdit ? true : false}
                rules={{ required: { value: true, message: 'This Vehicle Type field is required' } }}
                render={({ field }) => <Form.Select className="form-select selectPalceholdr inputLoginVehicle" name='vehicle_type' defaultValue={field.value} {...field}>
                  <option value=''>Please Select Vehicle Type</option>
                  {vehicleDetailsList?.vehicletype?.map((item, itemIndex) => <option key={itemIndex} value={item?.id}>{item?.name}</option>)}
                </Form.Select>}
              />
            </InputGroup>
              {errors?.vehicle_type && <Form.Text className="text-danger errorVehilceMessage">{errors?.vehicle_type?.message}</Form.Text>}
            </> : null}

          {/* vehicle type input section end  */}

          <InputGroup className="mb-3">
            <InputGroup.Text id="inputVehicleClass"><span className='mt-1' style={{ height: '27px', width: '27px' }}>{getSvgIcon('color_image', 'var(--bs-primary)')}</span></InputGroup.Text>
            {/* <Form.Control placeholder="Color" name='color' maxLength={10} minLength={3} className='inputLoginVehicle' aria-label="Username" aria-describedby="basic-addon1"
              {...register('color', {
                // required: true,
                // minLength: { value: 3, message: 'Please enter vehicle color' },
                // maxLength: 10
              })}
            />  */}
            <Controller
              name='color'
              id='color'
              className='inputLoginVehicle'
              control={control}
              disabled={isInEdit ? true : false}
              // rules={{ required: true }}
              render={({ field }) => <Form.Select className="form-select selectPalceholdr inputLoginVehicle" name='color' defaultValue={field.value} {...field}>
                <option value=''>Please Select Color</option>
                {vehicleDetailsList?.color?.map((item, itemIndex) => <option key={itemIndex} value={item?.id}>{item?.name}</option>)}
              </Form.Select>}
            />
          </InputGroup>
          {/* {errors?.color?.type === 'required' && <Form.Text className="text-danger errorVehilceMessage">This field is required</Form.Text>} */}
          {/* {errors?.color?.type === 'minLength' && <Form.Text className="text-danger errorVehilceMessage">{errors?.color?.message}</Form.Text>} */}

          <InputGroup className="mb-3">
            <InputGroup.Text id="inputVehicleClass"><span className='mt-1' style={{ height: '27px', width: '27px' }}>{getSvgIcon('Country', 'var(--bs-primary)')}</span></InputGroup.Text>
            <Controller
              name='state_id'
              id='state_id'
              className='inputLoginVehicle'
              control={control}
              disabled={isInEdit ? true : false}
              // rules={{ required: true }}
              render={({ field }) => <Form.Select className="form-select selectPalceholdr inputLoginVehicle" name='state_id' defaultValue={field.value} {...field}>
                <option>Please Select</option>
                {stateList?.map((item, itemIndex) => <option key={itemIndex} value={item?.id}>{item?.state_code}</option>)}
              </Form.Select>}
            />
          </InputGroup>
          {/* {errors?.state_id?.type === 'required' && <Form.Text className="text-danger errorVehilceMessage">This field is required</Form.Text>} */}

          {vehicleDefault ? <div className="form-check position-absolute">
            <input className="form-check-input" type="checkbox" name='status_default' checked={vehicleDefault ? true : false} {...register('status_default', { checked: false })} />
            <label className="form-check-label" id='setDefaultCheckbox'>Set as default</label>
          </div> : <div className="form-check position-absolute">
            <input className="form-check-input" type="checkbox" name='status_default' {...register('status_default', { checked: false })} />
            <label className="form-check-label" id='setDefaultCheckbox'>Set as default</label>
          </div>}

          <button type="submit" name="submit" className="btn w-100 my-4 text-white bg-primary VehicleeAddButton" disabled={(isFetching) ? true : false} onClick={handleSubmit}>
            <div className='d-flex justify-content-center align-items-center'>
              <span>{(isInEdit) ? 'Edit Vehicle' : 'Add Vehicle'} </span>  <span className='ms-2'>
                {(isFetching) ? <Circles
                  height="20"
                  width="20"
                  style={{ display: 'inline-block' }}
                  color="#ffffff"
                  ariaLabel="circles-loading"
                  visible={true}
                /> : null}
              </span>
            </div>
          </button>
        </Form>
      </Container>
    </div>
  )
}

VehicleForm.propTypes = {
  dispatch: PropTypes.func,
  loader: PropTypes.bool,
  isFetching: PropTypes.bool,
  notify: PropTypes.func,
  setIsVehicleModalOpen: PropTypes.bool,
  isInTransient: PropTypes.bool,
  isInEdit: PropTypes.bool,
  editData: PropTypes.object,
  partnerDetails: PropTypes.object,
}

VehicleForm.defaulProps = {
  dispatch: noop,
  loader: true,
  isFetching: true,
  notify: noop,
  setIsVehicleModalOpen: false,
  isInTransient: false,
  isInEdit: false,
  editData: EMPTY_OBJECT,
  partnerDetails: EMPTY_OBJECT
}

function mapStateToProps({ VehilceReducer, userDetailsReducer }) {
  const { isFetching } = VehilceReducer
  return { isFetching, partnerDetails: userDetailsReducer?.partnerDetails?.data }
}
export default connect(mapStateToProps)(VehicleForm)